var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtecaopoupanca(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 39.2C16.4 41.3 18.1 43 20.2 43C22.3 43 24 41.3 24 39.2V22.2M30 36.6C30 38 32.5 39.1 35.5 39.1C38.5 39.1 41 38 41 36.6M41 32.6C41 31.2 38.5 30.1 35.5 30.1C32.5 30.1 30 31.2 30 32.6M7 22.2C7 12.7 14.6 5 24 5C33.4 5 41 12.7 41 22.2H7ZM41 40.5C41 41.9 38.5 43 35.5 43C32.5 43 30 41.9 30 40.5V32.5C30 33.9 32.5 35 35.5 35C38.5 35 41 33.9 41 32.5V40.5Z",
    stroke: "#FF5800",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtecaopoupanca);
export default __webpack_public_path__ + "static/media/protecaopoupanca.8e2f6a062f6352c17ced92e8eb288285.svg";
export { ForwardRef as ReactComponent };